import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Header } from "../Layout";
import TokenSaleNoMeta from '../TokenSaleNoMeta';
import TokenSaleMeta from '../TokenSaleMeta';

class Tokensale extends React.Component {
    render() {
        return (
            <div>
                <Header />
                <div style={{ height: 100 }} />
                <div>
                    <TokenSaleMeta />
                </div>
                <div style={{ height: 100 }}>
                    <TokenSaleNoMeta />
                </div>
                <ToastContainer />
            </div>
        );
    }
}

export default Tokensale;
